import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.recruitments.offers');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-recruitments-offers',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.recruitments.offers/view.scss */
/* src/app/page.recruitments.offers/view.scss: no such file or directory */`],
})
export class PageRecruitmentsOffersComponent implements OnInit {
    public id: string = "";
    public loading: boolean = true;
    public payload: any = null;
    public items: any[] = [];
    public permissions: any = {};
    public uiPolicy: any = {
        solo_admin_mode: true,
        solo_admin_applies: false
    };
    public accessError: string = "";
    public filters: any = {
        status: ""
    };

    constructor(@Inject( Service) public service: Service) {
        this.id = WizRoute.segment.id;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.accessError = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("list_offer_negotiations", {
            id: this.id,
            recruitment_id: this.id,
            status: this.filters.status
        });
        if (code === 200 && data?.ok !== false) {
            this.payload = data;
            this.items = data.items || [];
            this.permissions = data.permissions || {};
            this.updateUiPolicy(data);
        } else {
            this.payload = null;
            this.items = [];
            this.accessError = this.safeErrorMessage(code, message || data?.message, "처우 협의 목록 조회 중 오류가 발생했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public statusOptions() {
        return this.payload?.status_options || [{ key: "", label: "전체" }];
    }

    public async applyFilters() {
        await this.load();
    }

    public async resetFilters() {
        this.filters = { status: "" };
        await this.load();
    }

    public openDetail(item: any) {
        if (!item?.detail_url) return;
        location.href = item.detail_url;
    }

    public updateUiPolicy(data: any) {
        const policy = data?.ui_policy || data?.permissions?.ui_policy || null;
        if (policy) this.uiPolicy = { ...this.uiPolicy, ...policy };
    }

    public soloAdminMode() {
        return !!this.uiPolicy?.solo_admin_mode && !!this.uiPolicy?.solo_admin_applies;
    }

    public compactStatusLabel(label: any) {
        const text = String(label || "").trim();
        if (!text) return "";
        if (text.includes("권한")) return text;
        if (/최종 미확정|관리자 확정 필요|관리자 확인 필요|담당자 확인 필요/.test(text)) return "미확정";
        return text;
    }

    public offerStatusLabel(item: any) {
        const label = item?.status_label || item?.status || "";
        return this.soloAdminMode() ? this.compactStatusLabel(label) : label;
    }

    public safeErrorMessage(code: number, message: string, fallback: string) {
        if (code === 403) return "권한이 필요합니다.";
        const text = String(message || "").trim();
        if (!text || /Traceback|File \"|\/opt\/|storage_key|file_path|<html/i.test(text)) return fallback;
        return text.length > 140 ? `${text.slice(0, 140).trim()}...` : text;
    }

    public badgeClass(status: any) {
        const value = String(status || "");
        if (["ACCEPTED", "FINAL_ACCEPTED"].includes(value)) return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (["DECLINED", "WITHDRAWN"].includes(value)) return "bg-rose-50 text-rose-700 border border-rose-200";
        if (["IN_PROGRESS", "OFFER_SENT"].includes(value)) return "bg-amber-50 text-amber-700 border border-amber-200";
        return "bg-zinc-50 text-zinc-600 border border-zinc-200";
    }
}

export default PageRecruitmentsOffersComponent;